export default "__VITE_ASSET__DJZkgPIo__"